<template>
    <div>
        <Header :logged="logged" :home="false" />
        <div flex class="spinner" v-if="loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div> 
        <b-modal ref="modalErro" title="Atenção">{{msgValida}}</b-modal>
        <protestoanuenciacancelamento  :itemsp="itemsCancelamento" v-if="itemsCancelamento.length > 0 "/>
        <editaleletronico  :itemsp="itemsEdital" v-if="itemsEdital.length > 0 "/>
        <b-modal
            ref="modalInstrumento"
            size="xl"
            scrollable
            title="Verificação de Autenticidade"
            id="modal-dialog"
        >
             <iframe :src="pdf" width="100%" height="500px" v-if="tipoServicoConsulta != 2"></iframe>
             <pdf :src="pdf" width="100%" height="500px" v-if="tipoServicoConsulta == 2"></pdf>
        </b-modal>

        <b-modal ref="modalErro" title="Atenção">{{msgValida}}</b-modal>
        
        <div  id="servico-resumo" class="servico-resumo-container" v-show="ready">
            <div class="servico-resumo-split-container left-container">
                <div class="servico-resumo-content">
                    <div v-if="servico.login && mobile">
                        <b-button href="/cadastro" class="btn-gradiente btn-cadastro" >Cadastre-se</b-button>
                        <h2>ou</h2>
                        <b-button href="/login" class="btn-blue btn-login" >Entrar</b-button>
                    </div>
                    <h1>{{servico.titulo}}</h1>
                    <div v-html="servico.descricao"></div>
                    <b-button
                      v-if="servicoSelecionado === 'renegociacao-dividas-protestadas'"
                      href="/renegociacao_divida/solicitacao"
                      variant="primary"
                      class="mt-3"
                    >
                      Solicitar Renegociação
                    </b-button>
                    <p v-if="servico.login && !logged">Cadastre-se ou faça login para enviar {{ servico.servico }} de maneira rápida, fácil e eficiente.</p>
                    <div class="servico-resumo-input-container">
                        <b-button v-if="servico.login && !mobile && !logged" href="/cadastro" class="btn-gradiente btn-cadastro" >Cadastre-se</b-button>

                        <template v-if="servico.interacao.hasInput && ((servico.login && logged) || !servico.login) && servico.interacao.inputs">
                            
                            <b-form-group 
                                v-for="(input, index) in servico.interacao.inputs"
                                :key="index"
                                :label="input.label" 
                                :label-for="input.id"
                            >
                                <div class="servico-resumo-input"> 
                                    <the-mask v-if="input.id === 'cpf_cnpj'"
                                        v-model="inputConsulta[input.model]"
                                        :id="input.id"
                                        :class="input.class" 
                                        :mask="[input.mask.cpf, input.mask.cnpj]"
                                        :placeholder="input.placeholder"
                                    />
                                    <the-mask v-else
                                        :id="input.id"
                                        v-model="inputConsulta[input.model]" 
                                        :class="input.class"
                                        :mask="input.mask"
                                        :placeholder="input.placeholder"
                                    />
                                </div>
                            </b-form-group>

                            <b-form-group>
                                <div class="servico-resumo-input">
                                    <div class="servico-resumo-btn-consultar">
                                        <vue-recaptcha
                                            ref="invisibleRecaptcha"
                                            :load-recaptcha-script="true"
                                            @verify="onVerify"
                                            @expired="onExpired"
                                            size="invisible"
                                            :sitekey="sitekey"
                                            badge="bottom"
                                        >
                                        </vue-recaptcha>
                                        <button type="button" class="bt-consultar" style="margin-left: 10px;" @click="consultar()" aria-label="Consultar">
                                            <font-awesome-icon size="1x" icon="search"/>
                                        </button>
                                    </div>
                                </div>
                            </b-form-group>
                        </template>

                        <b-form-group 
                            v-else-if="servico.interacao.hasInput && ((servico.login && logged) || !servico.login) && servico.interacao.input" 
                            :label="servico.interacao.input.label" 
                            :label-for="servico.interacao.input.id"
                        >
                            <div class="servico-resumo-input"> 
                                
                                <the-mask v-if="servico.interacao.input.id === 'cpf_cnpj'"
                                    v-model="inputConsulta.valor" 
                                    :id="servico.interacao.input.id"
                                    :class="servico.interacao.input.class" 
                                    :mask="[servico.interacao.input.mask.cpf, servico.interacao.input.mask.cnpj] "
                                    :placeholder="servico.interacao.input.placeholder"
                                />
                                <the-mask v-else
                                    :id="servico.interacao.input.id"
                                    v-model="inputConsulta.valor" 
                                    :class="servico.interacao.input.class"
                                    :mask="servico.interacao.input.mask"
                                    :placeholder="servico.interacao.input.placeholder"
                                />
                                
                                <div class="servico-resumo-btn-consultar">
                                    <vue-recaptcha
                                        ref="invisibleRecaptcha"
                                        :load-recaptcha-script="true"
                                        @verify="onVerify"
                                        @expired="onExpired"
                                        size="invisible"
                                        :sitekey="sitekey"
                                        badge="bottom"
                                    >
                                    </vue-recaptcha>
                                    <button type="button" class="bt-consultar" @click="consultar()" aria-label="Consultar">
                                        <font-awesome-icon size="1x" icon="search"/>
                                    </button>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                    <!-- <tutoriaisrelacionados :size="2" :tutorialTitle="false" :tutoriasCaller="true" :carousel="false"/> -->
                </div>

            </div>
            <div class="servico-resumo-split-container right-container">
                <div class="servico-resumo-bg" :id="(servico.login? 'servico-resumo-bg-gray': 'servico-resumo-bg-filter')"></div>
                <cardlogin v-if="servico.login && !logged" :cardStyle="'bg-transparent'" :cadastro="false" />
                <img v-else v-bind="bgImgProperties" :src="getImg(servico.interacao.imgBanner)"/>
            </div>
            <b-modal ref="login-cadastro" id="modal-consulta-login">
                <b-tabs>
                    <b-tab title="Já sou cadastrado" active>
                        <cardlogin :cardStyle="'cardlogin-modal bg-white'" :pesquisa="true" @loginpesquisa="retorno_login"  />
                    </b-tab>
                    <b-tab title="Cadastro Simplificado">
                        <cadastrosimples @cadastropesquisa="retorno_cadastro" />
                    </b-tab>
                </b-tabs>
            </b-modal>
        </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
    </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import Header from '../components/Header'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import cardlogin from '../components/login/card_login';
import tutoriaisrelacionados from '../components/tutoriais_relacionados';
import editaleletronico from "../components/edital_eletronico";
import Serv from "../services"
import API from '../services/api'
import VueRecaptcha from "vue-recaptcha";
import { TheMask } from "vue-the-mask";
import pdf from "vue-pdf";
import protestoanuenciacancelamento from "../components/protesto_anuencia_cancelamento";
import cadastrosimples from "../components/cadastro/simples";


export default {
  components: {
    VueRecaptcha,
    Header,
    footersite,
    footersitemobile,
    TheMask,
    cardlogin,
    tutoriaisrelacionados,
    pdf,
    editaleletronico,
    BeatLoader,
    protestoanuenciacancelamento,
    cadastrosimples
  },
  data() {
    return {
        logged: false,
        loading: false,
        ic_ibama: false,
        mobile: window.innerWidth < 1200,
        ready:false,
        msgValida:'',
        pdf:'',
        itemsCancelamento:{},
        itemsEdital:{},
        captchaToken: '',
        sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
        inputConsulta: {
                valor: '',
                chave: '',  
                folha: '',  
                livro: ''   
            },
        servicoSelecionado: '',
        tipoServicoConsulta:'',
        bgImgProperties:{
            style:{
                'width': '50vw',
                'height': 'calc(100vh - 120px - 36px)',
                'object-fit': 'cover',
            },
        },
        servico: {
            titulo:'',
            servico: '',
            descricao:'',
            login: true,
            interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:'' }
        },
        servicos:{
            'envio-de-titulo':{
                titulo:'Envio de título para protesto',
                servico: 'títulos',
                descricao:`Envie a protesto, de forma eletrônica, suas duplicatas, cheques, notas promissórias, contratos, sentenças judiciais, encargos condominiais ou qualquer outro título de crédito ou documento de dívida. `,
                login: true,
                interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:''},
                redirectUri:'/PedidoProtesto',
                nivelGov: '2', // prata
            },
            'consulta-documento':{
                titulo:'Consulta de CPF ou CNPJ',
                servico: 'consulta de documento',
                descricao:`Os Cartórios de Protesto disponibilizam a consulta de protesto de CPF e CNPJ de forma fácil, rápida e gratuita.

                            Com a consulta de protesto você poderá saber:
                            Se existem protestos e em quais cartórios.

                            Com esta informação, procure o credor, regularize a dívida e cancele o protesto no cartório indicado.
                            Se existem protestos com autorização de cancelamento`,
                login: false,
                interacao:{
                    hasInput:true,
                    input:{
                        label:'Consultar CPF ou CNPJ',
                        placeholder:'CPF ou CNPJ',
                        class: 'cpf-cnpj-input form-control',
                        id:'cpf_cnpj',
                        mask :{
                            cpf:'###.###.###-##',
                            cnpj:'##.###.###/####-##'
                        }
                    },
                    // imgBanner:'corporate-businessmen-working-tablet-office.png'
                    imgBanner:'consVerificacao.jpg'
                }
            },
            'autenticidade-protesto':{
                titulo:'Verificação de Autenticidade',
                servico: 'autênticidade de protesto',
                descricao:'O verificador de autenticidade permite que os  instrumentos de protesto expedidos de forma eletrônica possam ter a sua autenticidade verificada de maneira segura. Informe a chave única localizada no instrumento de protesto.',
                login: false,
                interacao:{
                    hasInput:true,
                    // imgBanner:'03@2x.png'
                    imgBanner:'8.jpg',
                    inputs: [
                        {
                            label: 'Chave única', // Label ficou mais específica
                            placeholder: 'Insira a chave única',
                            class: 'autenticidade-protesto form-control',
                            id: 'autenticidade_protesto_chave',
                            mask: '#######################',
                            model: 'chave'
                        },
                        {
                            label: 'Folha', // Novo campo
                            placeholder: 'Nº da folha',
                            class: 'autenticidade-protesto-folha form-control',
                            id: 'autenticidade_protesto_folha',
                            mask: '#########', // Ajuste a máscara conforme necessário
                            model: 'folha' // Propriedade para o v-model
                        },
                        {
                            label: 'Livro', // Novo campo
                            placeholder: 'Nº do livro',
                            class: 'autenticidade-protesto-livro form-control',
                            id: 'autenticidade_protesto_livro',
                            mask: '#########', // Ajuste a máscara conforme necessário
                            model: 'livro' // Propriedade para o v-model
                        }
                    ]
                }
            },
            'renegociacao-dividas-protestadas': {
                titulo: 'Renegociação de Dívidas Protestadas',
                servico: 'renegociação de protesto',
                login: false,
                descricao: `
                    <p>
                    Serviço destinado à renegociação de dívidas protestadas em cartório. Permite ao devedor propor condições de pagamento, descontos, aumentos ou multas, e negociar diretamente com o credor para regularizar sua situação.
                    </p>
                    <ul>
                    <li>Solicite renegociação de títulos protestados diretamente pelo sistema.</li>
                    <li>Informe percentuais de desconto, aumento ou multa conforme sua proposta.</li>
                    <li>Acompanhe o status da solicitação e negocie com o credor.</li>
                    <li>Após aprovação, efetue o pagamento e regularize sua situação.</li>
                    </ul>
                `,
                interacao: {
                    hasInput: false,
                    imgBanner: '8.jpg'
                }
            },
            'solicitacao-cancelamento':{
                titulo:'Solicitação de cancelamento',
                servico: 'solicitação de cancelamento',
                descricao:`O cancelamento de protesto também pode ser realizado de forma eletrônica nos casos em que o credor envia à Cenprot a autorização/anuência para o cancelamento.

                Solicite ao credor, no ato da quitação do título, que envie a autorização/anuência para o cancelamento de forma eletrônica via Cenprot.`,
                login: true,
                interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:''}
            },
            'pedido-cancelamento':{
                titulo:'Pedido de cancelamento',
                servico: 'pedido de cancelamento',
                descricao:`O Cancelamento de protesto é a forma do devedor regularizar sua situação após quitação da dívida junto ao Credor. O título protestado deve estar com autorização de cancelamento concedida pelo Credor para que o Protesto possa ser cancelado.

                O Cancelamento é rápido e On-line, cadastre-se e consulte seu documento (CPF/CNPJ) para verificar se existem títulos protestados que já podem ser cancelados.`,
                login: true,
                interacao:{
                    hasInput:true,
                    input:{
                        label:'Consultar CPF/CNPJ',
                        placeholder:'CPF/CNPJ',
                        class: 'cpf-cnpj-input form-control',
                        id:'cpf_cnpj',
                        mask :{
                            cpf:'###.###.###-##',
                            cnpj:'##.###.###/####-##'
                        }
                    },
                    imgBanner:'corporate-businessmen-working-tablet-office.png'
                },
                redirectUri: '#',
                nivelGov: '1'
            },
            'pedido-anuencia':{
                titulo:'Anuência / Autorização para cancelamento',
                servico: 'pedido de anuência/autorização para cancelamento',
                descricao:`A anuência/autorização para cancelamento eletrônica é concedida pelo credor quando da quitação do título. 

                            O credor, através da Cenprot, informa ao cartório que o devedor efetuou o pagamento da dívida e está autorizado a cancelar o protesto mediante o pagamento das despesas cartorárias.`,
                login: true,
                interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:''},
                redirectUri:'/anuenciaDigital',
                nivelGov: '3' // ouro
            },
            'consulta-edital':{
                titulo:'Consulta Edital', 
                servico: 'consulta de edital',
                descricao:'Consulte a existência de Intimaçoes por edital eletrônico para seu CPF/CNPJ',
                login: false,
                interacao:{
                    hasInput:true,
                    input:{
                        label:'Consulta Edital Eletrônico',
                        placeholder: 'Número do documento',
                        class: 'autenticidade-protesto form-control',
                        id:'cpf_cnpj',
                        mask :{
                            cpf:'###.###.###-##',
                            cnpj:'##.###.###/####-##'
                        }
                    },
                    imgBanner:'17.1.jpg'
                }
            },
            // 'quitar-debitos':{
            //     titulo:'Quitar débitos protestados',
            //     servico:'quitação de débitos protestados',
            //     descricao:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis condimentum metus et nulla hendrerit, nec cursus nisl placerat. Sed ultricies libero non tempor convallis.',
            //     login: true,
            //     interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:''}
            // },
            'pedido-certidao':{
                titulo:'Pedido de certidão',
                servico: 'pedido de certidão',
                descricao:`A Certidão de protesto eletrônica é um documento emitido pelo cartório solicitado, que informa a existência ou não de protestos em um CPF/CNPJ.

                            Solicite a sua certidão de protesto para qualquer cartório de protesto do Brasil, sem intermediários e online.`,
                login: true,
                interacao:{hasInput:false,input:{label:'',placeholder:'',class: '',id:'',mask :{}},imgBanner:''},
                redirectUri: '/certidaoNegativa',
                nivelGov: '1' // bronze
            },
            'autenticidade-certidao':{
                titulo:'Verificação de Autenticidade',
                servico: 'autênticidade certidão',
                descricao:'O verificador de autenticidade permite que a certidao digital possa ter a sua autenticidade verificada de maneira segura. Informe a chave única localizada na certidão.',
                login: false,
                interacao:{
                    hasInput:true,
                    input: {
                        label:'Verificador de autenticidade',
                        placeholder: 'Chave única',
                        class: 'autenticidade-certidao form-control',
                        id: 'autenticidade_certidao',
                        mask : '#######################',
                    },
                    imgBanner:'japones_1.png'
                }
            },
            'resolucoes-ieptb':{
              titulo:'Resoluções IEPTB',
              servico: 'resoluções IEPTB',
              descricao:`
                <div>
                  <h7>RESOLUÇÃO Nº 1, DE 05 DE NOVEMBRO DE 2019:</h7>
                  <p>Dispõe sobre normas técnicas para a implementação da Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães de Protesto de Títulos - CENPROT
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/191105_IEPTB_Resolucao_01.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 2, DE 09 DE NOVEMBRO DE 2021:</h7>
                  <p>Dispõe sobre normas técnicas e operacionais para a implantação da Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães de Protesto de Títulos - CENPROT
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_02_211109.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 3, DE 24 DE NOVEMBRO DE 2021:</h7>
                  <p>Dispõe sobre orientação aos tabeliães de protesto sobre o procedimento de cancelamento de protesto nas hipóteses de os efeitos do registro estarem suspensos por ordem judicial.
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_03_211124.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 4, DE 21 DE DEZEMBRO DE 2022:</h7>
                  <p>Dispõe sobre procedimentos para geração de Notas Fiscais para os valores dos serviços complementares de títulos apresentados por Bancos e Empresas
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_04_221221.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 5, DE 07 DE FEVEREIRO DE 2023:</h7>
                  <p>Dispõe sobre procedimento de repasse dos valores de emolumentos relativo aos pedidos de certidão, cancelamento e protesto com custas antecipadas, realizados por meio da Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães de Protesto de Títulos - CENPROT
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_05_070223.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 6, DE 23 DE MAIO DE 2023:</h7>
                  <p>Dispõe sobre procedimento administrativo no caso dos tabeliães de protesto que não cumprirem os prazos do SLA constantes do quarto aditivo do convênio Febraban.
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_06_230523.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 7, DE 30 DE JUNHO DE 2023:</h7>
                  <p>Dispõe sobre normas técnicas para a implantação do arquivo de ocorrências de andamento dos títulos apontados
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_07_300623.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 8, DE 19 DE DEZEMBRO DE 2023:</h7>
                  <p>Dispõe sobre normas técnicas para a publicação de editais por meio da CENPROT - Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães de Protesto
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/IEPTB_Resolucao_08_20122023_errata.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 9, DE 12 DE DEZEMBRO DE 2024:</h7>
                  <p>Dispõe sobre normas técnicas para a implantação do arquivo de emolumentos para cálculo de retiradas e cancelamentos.
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/241216_Resolucao_09_ArquivoEmolumentos.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 10, DE 17 DE DEZEMBRO DE 2024:</h7>
                  <p>Dispõe sobre a captação nacional pelos comerciais dos institutos seccionais e do IEPTB e, estabelece regras para a gestão dessa captação.
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/241217_Resolucao_10_GT_Comercial.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>

                  <h7>RESOLUÇÃO Nº 11, DE 6 DE AGOSTO DE 2025:</h7>
                  <p>Dispõe sobre normas técnicas para operacionalização da Solução Negocial Prévia (SNP), por meio da CENPROT - Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães de Protesto.
                    <br>
                    <a href="https://comunicados.cenprotnacional.org.br/250805_Resolucao_11_SNP.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Resolução
                    </a>
                  </p>
                </div>
              `,
              login: false,
              interacao:{
                hasInput:false,
                imgBanner:'8.jpg'
              }
            },
            'protesto-cda':{
              titulo:'Protesto CDA',
              servico: 'protesto CDA',
              descricao:`
                <div>
                  <p>Cartilha do CNJ, IEPTB e Confederação Nacional dos Municipios para Protesto da Certidão de Dívida Ativa - CDA.
                    <br>
                    <a href="../pdf/cartilhaProtestoCDA-20250806.pdf" target="_blank" style="color: #4780F1;">
                      <i class="fas fa-file" style="color: #4780F1; margin-right: 5px;"></i>Cartilha
                    </a>
                  </p>`,
              login: false,
              interacao:{
                hasInput:false,
                imgBanner:'17.1.jpg'
              }
            },
        }
    }
  },
  methods: {
    showModalError(error){
        this.msgValida = error;
        this.$refs["modalErro"].show();
    },
    getImg(imageSrc) {
        if (imageSrc.includes('png')) {
            var images = require.context('../assets/imgs/', false, /\.png$/);
        } else {
            var images = require.context('../assets/imgs/', false, /\.jpg$/);
        }
        return images('./' + imageSrc)
    },
    validar(documento) {
        documento = documento.replaceAll('.','');
        documento = documento.replaceAll('-','');
        documento = documento.replaceAll('/','');
        let len = documento.length;
        return len == 11 || len == 14 ? true : false;
    },
    validarCPF(documento) {
        documento = documento.replaceAll('.','');
        documento = documento.replaceAll('-','');
        var Soma;
        var Resto;
        Soma = 0;
        if (documento == "00000000000") return false;
        for (let i=1; i<=9; i++)
            Soma = Soma + parseInt(documento.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(documento.substring(9, 10)) ) return false;
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(documento.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(documento.substring(10, 11) ) ) return false;
        return true;
    },
    validarCNPJ(str) {
        str = str.replaceAll('.','');
        str = str.replaceAll('-','');
        str = str.replaceAll('/','');
        let cnpj = str;
        var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
        digitos_iguais = 1;
        if (cnpj.length < 14 && cnpj.length < 15)
            return false;
        for (let i = 0; i < cnpj.length - 1; i++)
            if (cnpj.charAt(i) != cnpj.charAt(i + 1))
        {
            digitos_iguais = 0;
            break;
        }
        if (!digitos_iguais)
        {
            tamanho = cnpj.length - 2
            numeros = cnpj.substring(0,tamanho);
            digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(0))
                return false;
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(1))
                return false;
            return true;
        }
        else
            return false;
    },
    getRouteRedirectTarget(servico){
        if(this.servicos[servico].redirectUri != null && this.servicos[servico].redirectUri != undefined && this.servicos[servico].redirectUri != '')
            return this.servicos[servico].redirectUri;
        else
            return '/Painel';  
    },
    switchServico(servico){
        this.servicoSelecionado = servico;
        if(this.servicos.hasOwnProperty(this.servicoSelecionado)) this.servico = this.servicos[this.servicoSelecionado];
        else this.servico = this.servicos['consulta-documento'];
        
        this.loading = false;
        this.ready = true;  
    },
    retorno_login(res){
        if(res.resposta){
            let documento = this.inputConsulta;
            this.loading = true;
            this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.captchaToken, totem: false, ic_ibama: this.ic_ibama } });
        }
    },
    retorno_cadastro(res){
        if(res.resposta){
            let documento = this.inputConsulta;
            this.loading = true;
            this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.captchaToken, totem: false, ic_ibama: this.ic_ibama } });
        }
    },
    consultar(){
        let captcha = this.$refs.invisibleRecaptcha.execute();
        setTimeout(() => {
                if(this.captchaToken != ''){
                    switch (this.servicoSelecionado) {
                        case 'autenticidade-protesto':
                            this.verificaAutenticidade(1);
                            break;
                        case 'autenticidade-certidao':
                            this.verificaAutenticidade(2);    
                            break;
                        case 'consulta-edital':
                            this.consultaEditalEletronico();
                            break;
                        case 'pedido-cancelamento':
                            this.consultaPedidoCancelamento();
                            break;
                        case 'consulta-documento':
                            this.consultaDocumento();
                            break;
                        case 'consulta-documento-ibama':
                            this.ic_ibama = true
                            this.consultaDocumento(this.ic_ibama);
                            break;
                    }
                }
        }, 1000)        
    },
    validarConsulta(documento){
        if(!this.validar(documento)) throw "CPF OU CNPJ INVALIDO!";
        if(documento.length == 11)
            if(!this.validarCPF(documento)) throw 'CPF INVÁLIDO';
        
        if(documento.length == 14){
            let documentoTronco = documento.substr(0,8)
            if(!this.validarCNPJ(documento)) throw 'CNPJ INVÁLIDO';
            else if(documentoTronco == '00360305') throw 'Consulta Bloqueada ';
        }
        return true;
    },
    consultaDocumento(){
        this.loading = true;
        let documento = this.inputConsulta.valor;
        try {
            let validacao = this.validarConsulta(documento);
            if(validacao) this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.captchaToken, totem: false } });
        } catch (error) {
            this.showModalError(error);
            return false
        }
    },
    consultaPedidoCancelamento(){
        this.loading = true;
        let documento = this.inputConsulta.valor;
        try {
            let validacao = this.validarConsulta(documento);
            if (validacao) {
                let self = this;
                API.get(`/pesquisa/tituloanuencia/${documento}/${self.captchaToken}`).then(res => {
                    if(res.data.result == 1){
                        self.itemsCancelamento = res.data['instrumentoProtesto'];
                        setTimeout(() => {
                            self.$bvModal.show('modal-anuecia-cancelamento');
                            this.loading = false;
                        }, 1500);
                    }
                    else throw 'Erro ao processar pedido';
                })
                .catch((error)=> {
                    this.loading = false;
                    this.showModalError(error);
                });
            }
        } catch (error) {
            this.loading = false;
            this.showModalError(error);
        }
        
    },
    consultaEditalEletronico(){
        if (this.inputConsulta.valor) {
            this.loading = true;
            API.get(`/pesquisa/pesquisaEditalEletronico/${this.inputConsulta.valor}/${this.captchaToken}`).then(res => {
                if(res.data.result == 1){
                    let self = this;
                    this.itemsEdital = res.data['editalEletronico'];
                    this.itemsEdital = res.data['editalEletronico'];
                    setTimeout(() => {
                        self.$bvModal.show('modal-edital-eletronico');
                    }, 0);
                }else {
                    this.msgValida = 'Não existe Edital Eletrônico publicado para o documento pesquisado';
                    this.$refs["modalErro"].show();
                }
                this.loading = false;
            })
            .catch((e)=> {
                this.msgValida = 'Servico indisponivel no momento, por favor, retorne a pesquisa em alguns minutos';
                this.$refs["modalErro"].show();
                // alert("Não foi possivel completar a solicitação");
                this.loading = false;
            });
        }
    },
    verificaAutenticidade(tipoServico){
        let chaveApi = ''
        const params = {};
        let folha = this.inputConsulta.folha || '0';
        let livro = this.inputConsulta.livro || '0';
        if (this.inputConsulta.valor || this.inputConsulta.chave) {
            if (this.inputConsulta.chave) {
                chaveApi = this.inputConsulta.chave;
                folha = this.inputConsulta.folha;
                livro = this.inputConsulta.livro;
                params.folha = this.inputConsulta.folha;
                params.livro = this.inputConsulta.livro;
                params.validacao_ip = 1
            } else {
                chaveApi = this.inputConsulta.valor;
            }
            this.loading = true;
            API.get(`VerifInstProt/${chaveApi}/${this.captchaToken}/${tipoServico}`, { params: params}).then(res => {
                if(res.data.result == 1){
                    // this.pdf = "data:application/pdf;base64," + res.data.instrumentoProtesto;
                    if(tipoServico == 2 )
                        this.pdf = res.data.instrumentoProtesto;
                    else 
                        this.pdf = "data:application/pdf;base64," + res.data.instrumentoProtesto;
                    // else this.pdf = res.data.instrumentoProtesto;

                    this.tipoServicoConsulta = tipoServico
                    
                    this.$refs["modalInstrumento"].show();
                }else {
                    this.msgValida = 'Chave única não encontrada ou invalida.';
                    this.$refs["modalErro"].show();
                }
                this.loading = false;
            })
            .catch((res)=> {
                alert("Não foi possivel completar a solicitação");
                this.loading = false;
            });
        }
    },
    onVerify: function(response) {
        this.captchaToken = response;
        this.resetRecaptcha();
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset();
    },
  },
  beforeMount(){
    this.loading = true;
    this.$root.isLogged().then((res) => {
        this.logged = true;
        let govLogin = this.$root.isLoggedGov();
        if(this.servicos[this.$route.params.servico].login && this.$route.params.servico !== 'pedido-cancelamento') {
            let routeTarget = this.getRouteRedirectTarget(this.$route.params.servico);
            if(govLogin){
                if(localStorage.getItem("lhwvzhds3") === this.servicos[this.$route.params.servico].nivelGov);
                this.$router.push({ path: routeTarget });
            }
            else{
                this.$router.push({ path: routeTarget });
            }
        }
        else this.switchServico(this.$route.params.servico);
        this.loading = false;
    }).catch((e) => {
        this.logged = false;
        this.switchServico(this.$route.params.servico);
    });
  },
  mounted() {
    this.inputConsulta.valor = this.$route.params.param_1 || '';
    this.mobile = window.innerWidth < 1200;
  }
}
</script>
<style scoped>
.servico-resumo-container{width: 100vw;margin: 0 auto;display: flex;height: calc(100vh - 120px - 36px);}
    .servico-resumo-container .servico-resumo-split-container{width: 50%;height: 100%;display: flex;flex-flow: column;max-height: 100%;overflow-y: auto;}
        .servico-resumo-container .servico-resumo-split-container.left-container{padding: 3.2vw 5vw 0 73px;}
        .servico-resumo-container .servico-resumo-split-container h1{text-align: left;font: normal normal 100 50px/55px 'Kanit', sans-serif;letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 11px;}
        .servico-resumo-container .servico-resumo-split-container p{text-align: left;font: normal normal 200 16px/20px 'Kanit', sans-serif;letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 2.4vw;}
        .servico-resumo-container .servico-resumo-split-container .servico-resumo-input-container{margin-bottom: 3.1vw;}
                .servico-resumo-container .servico-resumo-split-container .servico-resumo-input-container .form-group label{text-align: left;font: normal normal 200 16px/32px 'Kanit', sans-serif;letter-spacing: -1%;color: var(--secondary-color);}
        .servico-resumo-container .servico-resumo-split-container .servico-resumo-input{display: flex;width: 100%;}
            .servico-resumo-container .servico-resumo-split-container .servico-resumo-input input{width: 100%;height: 49px;text-align: left;font: normal normal 200 20px/32px 'Kanit', sans-serif;letter-spacing: -1%;color: var(--secondary-color);background: var(--light-gray-color) 0% 0% no-repeat padding-box;border:none;border-radius: 40px;padding: 0 20px; min-width: 340px;}
            .servico-resumo-container .servico-resumo-split-container .servico-resumo-input .servico-resumo-btn-consultar button{height: 49px;width: 90px;background-color: var(--primary-color);border: none;border-radius:40px;padding: 0 !important;color: white;position:absolute;margin-left: -90px;}
        .servico-resumo-container .servico-resumo-split-container .btn-gradiente{background: transparent linear-gradient(270deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;border: 3px solid #4780F1;color: #FFFFFF;}
            .servico-resumo-container .servico-resumo-split-container .btn-gradiente:hover{background: transparent linear-gradient(270deg,  #4780F1 0%, #4780F1 100%) 0% 0% no-repeat padding-box;}
        .servico-resumo-container .servico-resumo-split-container .btn-cadastro{width: 139px;height: 41px;font: normal normal bold 15px/20px 'Kanit', sans-serif;letter-spacing: 0px; border-radius: 5px;border: none;display: flex;align-items: center;justify-content: center;padding: 0;}


        .servico-resumo-container .servico-resumo-split-container.right-container{justify-content: center;align-items: center;overflow: hidden;}
            .servico-resumo-container .servico-resumo-split-container.right-container .servico-resumo-bg{width: 50vw;height: calc(100vh - 120px - 36px);position: absolute;right: 0;}
                .servico-resumo-container .servico-resumo-split-container.right-container #servico-resumo-bg-gray.servico-resumo-bg{background: #F1F1F1 0% 0% no-repeat padding-box;z-index: -1;}
                .servico-resumo-container .servico-resumo-split-container.right-container #servico-resumo-bg-filter.servico-resumo-bg{background: transparent linear-gradient(289deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;mix-blend-mode: lighten;opacity: 0.84;z-index: 5;}

    
    @media (max-width: 1600px) and (min-width: 1400px) {
        .servico-resumo-container .servico-resumo-split-container.left-container{padding-left: 20px;padding-top: 2vw;}
    }
    @media (max-width: 1399px) and (min-width: 1200px){
        .servico-resumo-container .servico-resumo-split-container.left-container{padding-left: 10px;padding-top: 2vw;}
    }
    @media (max-width: 1199px){
        .servico-resumo-container .servico-resumo-split-container h1{font: normal normal 100 50px/55px 'Kanit', sans-serif;margin-bottom:25px;}
        .servico-resumo-container .servico-resumo-split-container h2{text-align: center;font: normal normal bold 20px/27px 'Kanit', sans-serif;letter-spacing: 0px;color: #A8A8A8;margin-bottom:10px;}
        .servico-resumo-container .servico-resumo-split-container .servico-resumo-input-container{margin-bottom: 35px;}
        .servico-resumo-container {flex-flow: column;margin-top: 68px;margin-bottom: 43px;height: fit-content;min-height: calc(100vh - (241px + 136px + 43px + 68px));}
        .servico-resumo-container .servico-resumo-split-container.left-container{width: 100%;padding: 32px 20px 0 20px;height: fit-content;}
        .servico-resumo-container .servico-resumo-split-container.right-container{display: none;}
        .servico-resumo-container .servico-resumo-split-container .servico-resumo-input{width: 100%;}
        .servico-resumo-container .servico-resumo-split-container .servico-resumo-input input{width: 100%;}
        .servico-resumo-container .servico-resumo-split-container .btn-cadastro{width: 100%;height: 43px;margin-bottom: 10px;}
        .servico-resumo-container .servico-resumo-split-container .btn-login{margin-bottom: 25px;width: 100%;height: 43px;border: 3px solid #597EB5;border-radius: 5px;background-color: white;color: #597EB5;font: normal normal bold 15px/20px 'Kanit', sans-serif;letter-spacing: 0px;display: flex;align-items: center;justify-content: center;}
        .servico-resumo-container .servico-resumo-split-container .btn-login:hover{background-color: #597EB5;color: white;}

        .servico-resumo-container .servico-resumo-split-container .btn-cadastro:focus,
        .servico-resumo-container .servico-resumo-split-container .btn-login:focus{outline: none;box-shadow: none;}
        
    }
    @media print {* {display:none;}}
    
.spinner {position: absolute;width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;background: #000000aa;top: 0;left: 0;z-index: 100;}
.spinner-border{width: 200px;height: 200px;border: 17px solid #136BBF;border-right-color: rgb(19, 107, 191);border-right-color: transparent;}
</style>
